/**
 * 저장 데이터에서 문자열 값의 공백을 제거한다.
 *
 * - 코드/번호/구분/일자 계열 컬럼(cd_, no_, tp_, fg_, st_, yn_, dt_) : 값 안쪽 공백까지 전부 제거
 *   ex) 품목코드 "AB 100 " -> "AB100", 발주일 "2026 09 03" -> "20260903"
 * - 그 외 문자열 컬럼(nm_item, dc_rmk 등) : 앞뒤 공백만 제거
 *   문장 안의 띄어쓰기를 지우면 품목명/비고 내용이 깨지므로 trim 만 한다.
 *
 * 숫자/불린/null 은 손대지 않는다.
 * getChange() 결과(insert/update/delete 배열 + modifiedRowcount)를 그대로 넘길 수 있고,
 * 원본을 변경하지 않은 새 객체를 돌려준다.
 */

// 값 안쪽 공백까지 제거할 컬럼 접두어
const CODE_COLUMN = /^(cd_|no_|tp_|fg_|st_|yn_|dt_)/;

// 일반 공백 + 전각공백(　) + BOM(﻿)
const BLANK = /[\s　﻿]+/g;
const BLANK_EDGE = /^[\s　﻿]+|[\s　﻿]+$/g;

const stripBlanksFromString = (key: string, value: string) =>
  CODE_COLUMN.test(key)
    ? value.replace(BLANK, "")
    : value.replace(BLANK_EDGE, "");

const walk = (value: any, key: string): any => {
  if (typeof value === "string") return stripBlanksFromString(key, value);
  if (Array.isArray(value)) return value.map((item) => walk(item, key));
  if (value && typeof value === "object") {
    // Date 등 특수 객체는 그대로 둔다.
    if (Object.getPrototypeOf(value) !== Object.prototype) return value;
    const next: Record<string, any> = {};
    for (const [k, v] of Object.entries(value)) next[k] = walk(v, k);
    return next;
  }
  return value;
};

export const stripBlanksFromSaveData = <T>(saveData: T): T =>
  walk(saveData, "") as T;
